import styled from 'styled-components';

export const FormContainer = styled.div`
  margin-bottom: 50px;
`;
